export var CreatorApiEndpoint;
(function (CreatorApiEndpoint) {
    CreatorApiEndpoint["CREATOR_API_PROXY"] = "CREATOR_API_PROXY";
})(CreatorApiEndpoint || (CreatorApiEndpoint = {}));
